import { c as _c } from "react/compiler-runtime";
import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useHoverDirty } from 'react-use';
import Checkbox from 'components/consumer/Checkbox';
const CheckBlock = t0 => {
  const $ = _c(17);
  const {
    isSelected,
    label,
    description,
    onClick
  } = t0;
  const checkBlockRef = useRef(null);
  const isHovered = useHoverDirty(checkBlockRef);
  const t1 = !isSelected;
  let t2;
  if ($[0] !== isSelected || $[1] !== t1) {
    t2 = classNames("items-start rounded cursor-pointer flex flex-col justify-start pt-4 px-4 pb-5 bg-white", {
      "border-brand": isSelected,
      "border-gray-light7": t1
    });
    $[0] = isSelected;
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== label) {
    t3 = <span className="text-gray">{label}</span>;
    $[3] = label;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== isHovered || $[6] !== isSelected || $[7] !== t3) {
    t4 = <div><Checkbox checked={isSelected} isHovered={isHovered}>{t3}</Checkbox></div>;
    $[5] = isHovered;
    $[6] = isSelected;
    $[7] = t3;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== description) {
    t5 = <div className="text-xs font-bold text-gray ml-[30px] mt-[3px]">{description}</div>;
    $[9] = description;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== isSelected || $[12] !== onClick || $[13] !== t2 || $[14] !== t4 || $[15] !== t5) {
    t6 = <div ref={checkBlockRef} onClick={onClick} role="checkbox" aria-checked={isSelected} tabIndex={0} className={t2}>{t4}{t5}</div>;
    $[11] = isSelected;
    $[12] = onClick;
    $[13] = t2;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  return t6;
};
CheckBlock.propTypes = {
  isSelected: PropTypes.bool,
  label: PropTypes.string,
  description: PropTypes.string,
  onClick: PropTypes.func.isRequired
};
export default CheckBlock;